module.exports = __webpack_public_path__ + "img/1574357514.3afb7324.jpg";